import React, {useState} from 'react';
import {ConfigApi, MultistoreLayoutType, OrderType, PlaceApi} from "../../../../services/Api/types";
import MultistorePlaceCardCover from "./MultistorePlaceCardCover";
import MultistorePlaceCardFooter from "./MultistorePlaceCardFooter";
import {useNavigate} from "react-router-dom";
import StorageStore from "../../../../services/Common/Storage/storageStore";
import MultistoreOrderTypesModal from "../OrderTypesModal/MultistoreOrderTypesModal";
import {createKeyDownHandler} from "../../../../utils/keyDownHanlder";

interface Props {
    place: PlaceApi;
    layout: MultistoreLayoutType;
    setHoveredPlace?: React.Dispatch<React.SetStateAction<PlaceApi | undefined>>;
    preventOnClick?: boolean;
    selectedOrderType?: OrderType;
    withoutDeliveryInfo?: boolean;
    config: ConfigApi;
}

const MultistorePlaceCard = ({
                                 place,
                                 layout,
                                 setHoveredPlace,
                                 preventOnClick,
                                 selectedOrderType,
                                 withoutDeliveryInfo,
                                 config
                             }: Props) => {
    const navigate = useNavigate();
    const [showOrderTypesModal, setShowOrderTypesModal] = useState(false);

    const getProperPlaceLink = () => {
        let link = place.domain.replace(`${StorageStore.storeDomain}/`, "/");

        if (!link.startsWith('/')) {
            link = '/' + link;
        }

        return link;
    }

    const handleClick = () => {
        if (preventOnClick) return;

        const orderTypes = place.types;
        const link = getProperPlaceLink();

        if (orderTypes.length === 0) {
            navigate(link);
        } else if (orderTypes.length === 1) {
            navigate(`${link}/${orderTypes[0]}`);
        } else if (selectedOrderType) {
            navigate(`${link}/${selectedOrderType}`);
        } else {
            setShowOrderTypesModal(true);
        }
    }

    const handleOnKeyDown = () => createKeyDownHandler<HTMLDivElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: handleClick
    });

    return (
        <>
            <div className="place-card" onClick={handleClick} tabIndex={0} role="button" onKeyDown={handleOnKeyDown()}
                 onMouseEnter={() => setHoveredPlace?.(place)}
                 onMouseLeave={() => setHoveredPlace?.(undefined)}
                 style={{cursor: preventOnClick ? "default" : "pointer"}}
            >
                <MultistorePlaceCardCover place={place} layout={layout} config={config}/>
                <MultistorePlaceCardFooter place={place} layout={layout} withoutDeliveryInfo={withoutDeliveryInfo}/>
            </div>
            {
                showOrderTypesModal && (
                    <MultistoreOrderTypesModal
                        orderTypes={place.types} link={getProperPlaceLink()}
                        show={showOrderTypesModal} onHide={() => setShowOrderTypesModal(false)}/>
                )
            }
        </>
    )
}

export default MultistorePlaceCard;